import { render, staticRenderFns } from "./dataRoleTable.vue?vue&type=template&id=95f756a8&scoped=true"
import script from "./dataRoleTable.vue?vue&type=script&lang=js"
export * from "./dataRoleTable.vue?vue&type=script&lang=js"
import style0 from "./dataRoleTable.vue?vue&type=style&index=0&id=95f756a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f756a8",
  null
  
)

export default component.exports